import countries from "../../../countries.json";

const forms = [
  {
    name: "Details",
    options: [
      {
        name: "Image",
        type: "upload",
        form: {
          type: "text",
          name: "image",
          placeholder: "",
          class: "",
          value: "",
          required: false,
        },
      },
      {
        name: "Name",
        type: "input",
        form: {
          type: "text",
          name: "name",
          placeholder: "Branch name",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Email",
        type: "input",
        form: {
          type: "text",
          name: "email",
          placeholder: "Branch email",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Phone",
        type: "input",
        form: {
          type: "text",
          name: "phone",
          placeholder: "Branch phone",
          class: "",
          value: "",
          required: true,
        },
      },
    ],
  },
  {
    name: "Taxation",
    options: [
      {
        name: "Number",
        type: "input",
        form: {
          type: "text",
          name: "tax",
          placeholder: "Branch tax number",
          class: "",
          value: "",
          required: false,
        },
      },
    ],
  },
  {
    name: "Address",
    options: [
      {
        name: "Area",
        type: "input",
        form: {
          type: "text",
          name: "area",
          placeholder: "Customer area address",
          class: "",
          value: "",
        },
      },
      {
        name: "City",
        type: "input",
        form: {
          type: "text",
          name: "city",
          placeholder: "Customer city address",
          class: "",
          value: "",
        },
      },
      {
        name: "State",
        type: "input",
        form: {
          type: "text",
          name: "state",
          placeholder: "Customer state address",
          class: "",
          value: "",
        },
      },
      {
        name: "Country",
        type: "select",
        form: {
          value: "Oman",
          name: "country",
          allowClear: false,
          showSearch: true,
          placeholder: "Oman",
          options: countries?.map((value, index) => ({
            value: value?.country,
            label: value?.country,
          })),
          required: false,
        },
      },
    ],
  },
  {
    name: "Status",
    options: [
      {
        name: "Status",
        type: "select",
        form: {
          name: "status",
          allowClear: false,
          placeholder: "Status",
          value: 1,
          options: [
            {
              value: 1,
              label: "Active",
            },
            {
              value: 0,
              label: "In-active",
            },
          ],
          required: false,
        },
      },
    ],
  },
  {
    name: "Billing",
    options: [
      {
        name: "Billing",
        type: "select",
        form: {
          name: "billing",
          allowClear: false,
          placeholder: "Status",
          value: 0,
          options: [
            {
              value: 0,
              label: "POS",
            },
            {
              value: 1,
              label: "DEFAULT",
            },
          ],
          required: false,
        },
      },
    ],
  },
  {
    name: "Bank Details",
    options: [
      {
        name: "Bank Name",
        type: "input",
        form: {
          type: "text",
          name: "bank_name",
          placeholder: "e.g. Bank Muscat",
          class: "",
          value: "",
          required: false,
        },
      },
      {
        name: "Branch",
        type: "input",
        form: {
          type: "text",
          name: "bank_branch",
          placeholder: "Bank branch name",
          value: "",
          required: false,
        },
      },
      {
        name: "Account Name",
        type: "input",
        form: {
          type: "text",
          name: "bank_account_name",
          placeholder: "Account holder name",
          class: "",
          value: "",
          required: false,
        },
      },
      {
        name: "Account Number",
        type: "input",
        form: {
          type: "text",
          name: "bank_account_number",
          placeholder: "Account number",
          class: "",
          value: "",
          required: false,
        },
      },
      {
        name: "Swift Code",
        type: "input",
        form: {
          type: "text",
          name: "bank_swift",
          placeholder: "e.g. BMUSOMRX",
          value: "",
          required: false,
        },
      },
    ],
  },
  {
    name: "Fiscal Year Details",
    options: [
      {
        name: "Fiscal Years",
        type: "fiscalyear",
        form: {
          name: "fiscal_years",
          placeholder: "Add fiscal year periods",
          value: [],
          required: false,
        },
      },
    ],
  },
];

export default forms;
